import { DataDisplayContext } from "./data-display-context";
export const DataDisplayConsumer = DataDisplayContext.Consumer;